var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEssaiRugby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linejoin: round;\n        stroke-width: 1.81px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.37,32.04c6.42,13.71-5.56,32.87-26.75,42.79-21.19,9.92-43.58,6.85-49.99-6.85-6.42-13.71,5.56-32.87,26.75-42.79,21.19-9.92,43.57-6.85,49.99,6.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.93,23.35c-53.59-1.57-71.7,37.99-71.7,37.99.87,11.88,7.69,14.26,7.69,14.26,27.03,6.03,53.34-14.5,53.34-14.5,34.08-24.28,10.67-37.75,10.67-37.75ZM80.39,63.16c-35.68,12.15-38.46-.95-38.46-.95-1.26-21.38,37.76-35.13,37.76-35.13,25.25-7.6,31.39,2.38,31.39,2.38.79,2.36,1.51,3.67,1.51,3.67,5.6,17.3-32.2,30.03-32.2,30.03Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssaiRugby);
export default __webpack_public_path__ + "static/media/essai_rugby.4e6969bdd2f519d22ed10d5cffa22c0a.svg";
export { ForwardRef as ReactComponent };